import { addMetrics } from './metricsClient';
export default function adsenseLoadedCallback(adLoaded, requestedMetric, loadedMetric) {
  const INCREMENT_COUNT = 1;
  addMetrics({
    [requestedMetric]: INCREMENT_COUNT
  });
  if (adLoaded) {
    addMetrics({
      [loadedMetric]: INCREMENT_COUNT
    });
  }
}